export const pathnames = {
  HOME: '/',
  AUTH: '/auth',
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/logout',
  AUTH_REGISTER: '/auth/register',
  MAIN_MENU: '/',
  FORM_1: '/inspection/:shumaId/1',
  FORM_2: '/inspection/:shumaId/2',
  FORM_3: '/inspection/:shumaId/3',
  FORM_4: '/inspection/:shumaId/4',
  FORM_5: '/inspection/:shumaId/5',
  FORM_6: '/inspection/:shumaId/6',
  FORM_7: '/inspection/:shumaId/7',
  FORM_8: '/inspection/:shumaId/8',
  FORM_9: '/inspection/:shumaId/9',
  FORM_10: '/inspection/:shumaId/10',
  FORM_11: '/inspection/:shumaId/11',
  GET_FORM_BY_ID_AND_STEP: (shumaId, step = 1) => `/inspection/${shumaId}/${step}`,
  GET_INSPECTION_BY_ID: shumaId => `/inspection/${shumaId}/13`,
  INSPECTION: '/inspection',
  INSPECTION_ID: '/inspection/:shumaId',
  GET_INSPECTION_OTHER_BY_ID: shumaId => `/inspection-other/${shumaId}`,
  INSPECTION_OTHER: '/inspection-other',
  INSPECTION_OTHER_ID: '/inspection-other/:shumaId',
  INSPECTION_AND_FORM_IDS: '/inspection/:shumaId/:formId',
  NEW_INSPECTION_ID: '/new-inspection',
  COPY_INSPECTION: '/copy-inspection/:originShumaID',
  INSPECTED_LIST: '/inspected',
  DOCUMENTS_AND_REFERENCES: '/documents-and-references',
  ESTIMATES_REPOSITORY: '/inspected-database',
  ESTIMATES_DATABASE: '/inspected-firm',
  COMPLETE_INSPECTION: '/complete-inspection',
  TASKS: '/tasks',
  APPRAISALS: '/appraisals',
  TAX_AUTHORITY: '/tax-authority',
};